/**
 * 0以上max以下の整数を返す
 * @param max 整数
 */
export function randInt(max: number): number {
  return Math.floor(Math.random() * Math.floor(max + 1));
}
